import { render } from "./CIS-Home-Masthead.vue?vue&type=template&id=efae0606&scoped=true"
import script from "./CIS-Home-Masthead.vue?vue&type=script&lang=js"
export * from "./CIS-Home-Masthead.vue?vue&type=script&lang=js"

import "./CIS-Home-Masthead.vue?vue&type=style&index=0&id=efae0606&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efae0606"]])

export default __exports__